export class BasePage {
    public isBusy = true;
    public isLoading = false;

    public back() {
        window.history.back();
    }
}
